import { NetworkStrength2AlertIcon } from './NetworkStrength2AlertIcon';

/**
 * author: Simran
 * id DB8EEB5C-3705-4DE7-A770-D63ACE14F1BD
 * name network-strength-2-alert
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/network-strength-2-alert.svg
 * tags
 * - Cellphone / Phone 
 * - Alert / Error 
 */
export const NetworkStrength2WarningIcon = NetworkStrength2AlertIcon;
export default NetworkStrength2WarningIcon